__turbopack_context__.v({
  "iconChevron": "_4J2DWq_iconChevron",
  "isOpen": "_4J2DWq_isOpen",
  "link": "_4J2DWq_link",
  "title": "_4J2DWq_title",
});
